import React from 'react'

export default function Footer() {
  return (
    <footer>Developed with <span style={{color: 'red', fontSize: '25px'}}>&hearts;</span> by Dheeraj Roy</footer>
  )
}
